import { render, staticRenderFns } from "./nominated-inflation-table.vue?vue&type=template&id=39ef97c3&scoped=true"
import script from "./nominated-inflation-table.vue?vue&type=script&lang=ts"
export * from "./nominated-inflation-table.vue?vue&type=script&lang=ts"
import style0 from "./nominated-inflation-table.vue?vue&type=style&index=0&id=39ef97c3&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39ef97c3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39ef97c3')) {
      api.createRecord('39ef97c3', component.options)
    } else {
      api.reload('39ef97c3', component.options)
    }
    module.hot.accept("./nominated-inflation-table.vue?vue&type=template&id=39ef97c3&scoped=true", function () {
      api.rerender('39ef97c3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/inflation-step/nominated-inflation-table/nominated-inflation-table.vue"
export default component.exports